// Fuse-backed "did you mean?" fuzzy ranker. Shared between the engine's
// error suggestions (`errors.ts`) and the chat plugin's filter-literal
// recovery (`plugin-chat/.../recovery.ts`) — both need the same
// case-insensitive Bitap match against a candidate pool.

import Fuse from 'fuse.js';

/**
 * Rank `candidates` by fuzzy closeness to `query` and return the top-`k`
 * matches under `threshold` (Bitap score; 0 = exact, 1 = anything goes).
 * Case-insensitive. Empty query / empty candidate pool short-circuits
 * to `[]`.
 */
export const closestMatches = (
  query: string,
  candidates: readonly string[],
  opts: { k?: number; threshold?: number } = {},
): readonly string[] => {
  if (query.length === 0 || candidates.length === 0) {
    return [];
  }
  const { k = 3, threshold = 0.4 } = opts;
  const fuse = new Fuse(candidates as string[], { threshold, isCaseSensitive: false });
  return fuse.search(query, { limit: k }).map((r) => r.item);
};
